const monthArray = [
    { value: 'Jan',name:'January', id: 0 },
    { value: 'Feb',name:'February', id: 1 },
    { value: 'Mar',name:'March', id: 2 },
    { value: 'Apr',name:'April', id: 3 },
    { value: 'May',name:'May', id: 4 },
    { value: 'Jun',name:'June', id: 5 },
    { value: 'Jul',name:'July', id: 6 },
    { value: 'Aug',name:'August', id: 7 },
    { value: 'Sep',name:'September', id: 8 },
    { value: 'Oct',name:'October', id: 9 },
    { value: 'Nov',name:'November', id: 10 },
    { value: 'Dec',name:'December', id: 11 }
]

const monthname = (id) => {
    let ext = monthArray.find(itm => itm.id === id)
    return ext?ext?.name:'--'
}

const monthfind = (id) => {
    let value = 0
    let ext = monthArray.find(itm => itm.id === id)
    if (ext) value = ext.value
    return value
}

const getWeekDate = (date = new Date(), week = 1) => {
    let d = new Date(date)
    let month = d.getMonth()
    month = String(month + 1)

    let value = 1
    if (week == 1) value = 1
    else if (week > 1) value = 7 * (week - 1)
    if (value > 30) value = 30

    return new Date(`${d.getFullYear()}-${month}-${value}`)
}


const stringToDate = (p) => {
    let date = datetostring(p)
    if (date) date = date?.split('-')?.map(itm => Number(itm))
    return date?new Date(date[0], (date[1] - 1), date[2]):''
}

const date = (p,pipe='dd/mm/yyyy') => {
    if(!p) return ''
    let d = stringToDate(p)
    if(d=='Invalid Date'||!d) return ''

    let value=`${d.getDate()} ${monthfind(d.getMonth())} ${d.getFullYear()}`
    if(pipe=='mm/yyyy') value=`${monthfind(d.getMonth())} ${d.getFullYear()}`
    return value
}

const daysArray = [
    { value: 'Monday', id: 1 },
    { value: 'Tuesday', id: 2 },
    { value: 'Wednesday', id: 3 },
    { value: 'Thursday', id: 4 },
    { value: 'Friday', id: 5 },
    { value: 'Saturday', id: 6 },
    { value: 'Sunday', id: 0 },
]

const getDayName = (id) => {
    let value = daysArray.find((itm) => itm.id === id).value
    return value;
}

const day = (p) => {
    if (!p) return ''
    let day = new Date(p).getDay()
    day = getDayName(day)
    return day
}

const time = (p) => {
    if (!p) return ''
    let v = String(p)?.split('T')
    if (v.length === 2) {
        return new Date(p).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    } else {
        return new Date(p).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        // return new Date(`2020-07-19 ${p}`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    }
}

const datetime = (p) => {
    if(!p) return ''
    return `${date(p)}, ${time(p)}`
}

const timeString = (p) => {
    let date = new Date(p)
    let hr = String(date.getHours())
    let minutes = String(date.getMinutes())
    if (hr.length === 1) hr = `0${hr}`
    if (minutes.length === 1) minutes = `0${minutes}`
    return `${hr}:${minutes}:00`
}

// const datetostring = (p) => {
//     if (!p) return ''
//     let date = new Date(p)
//     if(p?.getFullYear) date=p
//     let month = String(date.getUTCMonth() + 1)
//     let d = String(date.getUTCDate())
//     if (month.length === 1) month = `0${month}`
//     if (d.length === 1) d = `0${d}`
//     return `${date.getUTCFullYear()}-${month}-${d}`
// }

const datetostring = (p) => {
    if (!p) return '';

    // If p is already a Date object
    if (p instanceof Date) {
        let year = p.getFullYear();
        let month = String(p.getMonth() + 1).padStart(2, '0');
        let day = String(p.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    // If p is a string in YYYY-MM-DD format
    if (typeof p === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(p)) {
        if(p=='Invalid Date') return ''
        return p?.replace('.000Z',''); // it's already in the right format
    }

    // Fallback: try parsing, but note it may be timezone shifted
    let date = new Date((typeof p === 'string'?p?.replace('.000Z',''):p));

    if(date=='Invalid Date') return ''
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};



const datetoIso = (p) => {
    if (!p) return ''
    let date = datetostring(p)

    let value = `${date}T00:00:00`
    return value
}

const datetoIsotime = (p) => {
    let date = datetostring(p)
    let time = timeString(p)
    let value = `${date}T${time}`
    return value
}

const datetoUtc = (p) => {
    if (!p) return '';
    const date = new Date(p);
    if (isNaN(date)) return ''; // Handle invalid date input

    let month = String(date.getUTCMonth() + 1).padStart(2, '0');
    let day = String(date.getUTCDate()).padStart(2, '0');
    let hours = String(date.getUTCHours()).padStart(2, '0');
    let minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${date.getUTCFullYear()}-${month}-${day}T${hours}:${minutes}`;
}

const utcToDate = (utcString) => {
    if (!utcString) return '';
    const date = new Date(utcString);
    if (isNaN(date)) return ''; // Handle invalid date input

    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}T${hours}:${minutes}`;
};

const isototime = (p) => {
    if (!p) return ''
    let value = p.split('T')[1].split('.')
    // if (value.length === 2) {
    // } else {
    //     value = p.split('T')[1].split('+')
    // }
    return value[0]
}

const isotime = (p) => {
    return time(isototime(p))
}

const isotodate = (p) => {
    let d = new Date(`${datetostring(p)} ${isototime(p)}`)
    return d
}

const datetodatepicker = (p) => {
    if(!p) return ''
    let value=p?.split('.')?.[0]
    return `${value}`
}

const DaysNo = (s, e) => {
    // JavaScript program to illustrate 
    // calculation of no. of days between two date 

    // To set two dates to two variables
    var date1 = new Date(s);
    var date2 = new Date(e);

    // To calculate the time difference of two dates
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    return Difference_In_Days + 1
}

function getHoursAndMinutes(s, e=new Date()) {
    let startDate=new Date(s)
    let endDate=new Date(e)
    // Convert dates to timestamps
    var startTimestamp = startDate.getTime();
    var endTimestamp = endDate.getTime();

    // Calculate the difference in milliseconds
    var difference = Math.abs(endTimestamp - startTimestamp);

    // Convert milliseconds to hours and minutes
    var hours = Math.floor(difference / (1000 * 60 * 60));
    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

    let value=''
    if(hours>24){
        let days=hours/24
        days=Math.round(days)
        // value=`${days} days`
        value=datetime(s)
    }else if(hours){
        value=`${hours} hours ${minutes?`and ${minutes} minutes`:''}`
    }else{
        value=`${minutes?`${minutes} minutes`:''}`
    }

    return value;
}
function getHoursAndMinutesSeconds(s, e = new Date()) {
    if (!s) return '';
    let startDate = new Date(s);
    let endDate = new Date(e);

    // Convert dates to timestamps
    var startTimestamp = startDate.getTime();
    var endTimestamp = endDate.getTime();

    // Calculate the difference in milliseconds
    var difference = Math.abs(endTimestamp - startTimestamp);

    // Convert milliseconds to hours, minutes, and seconds
    var hours = Math.floor(difference / (1000 * 60 * 60));
    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

    let value = '';
    if (hours >= 24) {
        let days = Math.floor(hours / 24);
        value = `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours) {
        value = `${hours} hour${hours>1?'s':''} ago`;
    } else if (minutes) {
        value = `${minutes} min ago`;
    } else {
        value = `Just Now`;
    }

    return value;
}



const addDays=(date,days=0)=>{
    let current=new Date(date)
    current.setDate(current.getDate()+days)
    return datetoIsotime(new Date(current))
}

const splitdate=()=>{

}

const datepipeModel = {
    datetoUtc,
    splitdate,
    utcToDate,
    DaysNo,
    date,
    getHoursAndMinutes,
    getHoursAndMinutesSeconds,
    stringToDate,
    day,
    datetostring,
    datetoIso,
    isototime,
    isotodate,
    isotime,
    datetoIsotime,
    time,
    timeString,
    datetime,
    monthfind,
    getWeekDate,
    monthname,
    monthArray,
    addDays,
    datetodatepicker
}

export default datepipeModel;
